import React, { Component } from 'react';
import './App.css';

let baseClass = 'gridImgThumb';
let selectClass= ' selected'

class GridItem extends Component {
	constructor(props) {
      super(props)
      this.state = { 
      	selected:false
      }
	 this.handleGIClick = this.handleGIClick.bind(this)
	}

	componentDidMount(){
      console.log("componentDidMount GridItem fired")
      this.props.regGI(this)
    }


	handleGIClick(){
		this.props.clickCB(this.props.name,this)
	}
	

  render() {
  	var currentImg=this.props.imgpath+this.props.imgsrc;
  	var selectClasses=baseClass+selectClass
  	var displayClasses=baseClass

    return (
    	<div className={this.state.selected ? selectClasses : displayClasses} onClick={this.handleGIClick} key={this.props.gikey}>
			<img src={require(`${currentImg}`)} className="GridImg" height={this.props.height} key={this.props.gikey} width={this.props.width} alt="test"/>
		</div>

    );
  }
}

export default GridItem;


// WEBPACK FOOTER //
// ./src/GridItem.js